import React from 'react'
import './certification.css'
import CertificateBanner from '../../Components/Verify Certificate/CertificateBanner'
import VerifyCertificate from '../../Components/Verify Certificate/VerifyCertificate'
import HomeServices from '../../Components/Home/HomeServices'

const CertificationPage = () => {
  return (
    <div>
      <CertificateBanner/>
      <VerifyCertificate/>
      <HomeServices/>
    </div>
  )
}

export default CertificationPage
